import { useState } from 'react';
import BubbleButton from './BubbleButton';
import BubbleModal from './BubbleModal';
import ThemeMenu from './ThemeMenu';

interface ThemeButtonProps { };

const ThemeButton: React.FC<ThemeButtonProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  return (
    <>
      <BubbleButton text='theme 🎨' onClick={() => setIsModalOpen(true)} />
      <BubbleModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        contentLabel='theme'
        children={<ThemeMenu />}
      />
    </>
  );
}

export default ThemeButton;
